import { render, staticRenderFns } from "./ProjectTextReport.vue?vue&type=template&id=2d4afce6&scoped=true"
import script from "./ProjectTextReport.vue?vue&type=script&lang=js"
export * from "./ProjectTextReport.vue?vue&type=script&lang=js"
import style0 from "./ProjectTextReport.vue?vue&type=style&index=0&id=2d4afce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4afce6",
  null
  
)

export default component.exports